import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./Modal.css";
import "./ObjectExplorerModals.css";

const EditObjectModal = ({ show, onHide, object, onSave, onShare }) => {
  const [newName, setNewName] = useState("");
  const [tags, setTags] = useState("");
  const [retention, setRetention] = useState(false);

  useEffect(() => {
    if (object) {
      const name = object.Key.split("/").filter(Boolean).pop();
      setNewName(name);
      setTags("");
      setRetention(false);
    }
  }, [object]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newName.trim()) return;

    onSave({
      newName: newName.trim(),
      tags: tags.trim(),
      retention,
    });
  };

  const handleShare = () => {
    if (onShare && object?.Key) {
      onShare(object.Key);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="object-modal">
      <Modal.Header closeButton>
        <Modal.Title>Editar Objeto</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Novo nome</Form.Label>
            <Form.Control
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              required
              placeholder="nome-do-arquivo.ext"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tags (formato: chave=valor,...)</Form.Label>
            <Form.Control
              type="text"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="ex: projeto=viadrive,env=prod"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Ativar retenção legal (Legal Hold)"
              checked={retention}
              onChange={(e) => setRetention(e.target.checked)}
            />
          </Form.Group>

          <Form.Group className="mb-3 text-center">
            <Button variant="outline-secondary" onClick={handleShare}>
              📤 Compartilhar
            </Button>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit">
            Salvar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditObjectModal;
